import React from "react";
import TrackCard from "./TrackCard";

export default function TrackGrid({ tracks = [], onTrackDeleted }) {
  if (!tracks.length) {
    return (
      <div style={{
        padding: '2rem',
        textAlign: 'center',
        backgroundColor: 'var(--surface-color)',
        border: '1px solid var(--border-color)',
        borderRadius: '12px',
        color: 'var(--text-secondary)'
      }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🎵</div>
        <p style={{ 
          fontSize: '1.1rem', 
          fontWeight: '600', 
          margin: '0 0 0.5rem 0',
          color: 'var(--text-primary)'
        }}>
          Your catalog is empty
        </p>
        <p style={{ 
          fontSize: '0.9rem', 
          margin: '0',
          color: 'var(--text-secondary)'
        }}>
          Add tracks to your catalog to see them here. Use the filters to refine your search.
        </p>
      </div>
    );
  }
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
      gap: '1.5rem'
    }}>
      {tracks.map((track, idx) => (
        <TrackCard
          key={track.id || track.track_id}
          track={track}
          index={idx + 1}
          onTrackDeleted={onTrackDeleted}
        />
      ))}
    </div>
  );
}
